import { render } from "./MyNotiList.vue?vue&type=template&id=339a4386&scoped=true"
import script from "./MyNotiList.vue?vue&type=script&lang=js"
export * from "./MyNotiList.vue?vue&type=script&lang=js"

import "./MyNotiList.vue?vue&type=style&index=0&id=339a4386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339a4386"]])

export default __exports__